import '../img/DataFiscal.jpg';
import '../img/GDA.jpg';
import '../img/Liniers-Horizontal.jpg';
import '../img/Liniers-Vertical.jpg';
import '../img/LN.svg';
import '../img/LN-Mas.svg';
import '../img/Lupa.svg';
import '../img/Sprite-Horoscopo.png';
import '../img/Sprite-Inputs-2.png';
import '../img/Tarjeta_ClubLN.png';


// WEBPACK FOOTER //
// ./Statics/scripts/ImagesImports.js